
class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.overlay = this.querySelector('.newsletter-popup-overlay');
    this.dismissButtons = this.querySelectorAll('[data-popup-dismiss]');
    this.copyButton = this.querySelector('[data-copy-coupon]');
    this.delay = (Number.parseInt(this.dataset.delay, 10) || 5) * 1000;
    this.frequency = Number.parseInt(this.dataset.frequency, 10) || 30;
    this.mode = this.dataset.mode || 'delay';
    this.storageKey = 'newsletter-popup-last-closed';
    // Marcado quando o cadastro foi concluido: o popup nao abre mais sozinho.
    this.subscribedKey = 'newsletter-popup-subscribed';
  }

  // localStorage pode lancar excecao (Safari privado, cookies bloqueados).
  // Sem este try/catch o connectedCallback quebrava e o popup nunca abria.
  storageGet(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  storageSet(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) { /* sem armazenamento: segue sem memoria */ }
  }

  connectedCallback() {
    if (!this.overlay) return;
    const isSuccess = !!this.querySelector('.newsletter-popup__success');

    if (isSuccess) {
      // Cadastro concluido: revela o beneficio (TOP5) e nao volta a abrir sozinho.
      this.storageSet(this.subscribedKey, String(Date.now()));
      this.storageSet(this.storageKey, String(Date.now()));
    } else if (this.forcedByUrl()) {
      // Teste manual: https://usetopbrands.com.br/#popup-top5 abre o popup ignorando a frequencia.
      this.timer = window.setTimeout(() => this.open(), 400);
    } else if (this.shouldShow()) {
      if (this.mode === 'exit_intent' && window.matchMedia('(pointer: fine)').matches) {
        this.exitHandler = (event) => {
          if (event.clientY <= 0) this.open();
        };
        document.addEventListener('mouseleave', this.exitHandler, { once: true });
      } else {
        this.timer = window.setTimeout(() => this.open(), this.delay);
      }
    }

    this.dismissButtons.forEach((button) => button.addEventListener('click', () => this.close()));
    this.overlay.addEventListener('click', (event) => {
      if (event.target === this.overlay) this.close();
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && this.overlay.classList.contains('is-visible')) this.close();
    });
    this.copyButton?.addEventListener('click', () => this.copyCoupon());

    if (window.Shopify?.designMode) {
      document.addEventListener('shopify:section:select', (event) => {
        if (event.target.contains(this)) this.open();
      });
    }

    if (isSuccess) this.open();
  }

  forcedByUrl() {
    return window.location.hash === '#popup-top5';
  }

  shouldShow() {
    if (window.location.pathname.includes('/challenge')) return false;
    if (window.Shopify?.designMode) return false;
    if (this.storageGet(this.subscribedKey)) return false;
    const lastClosed = Number.parseInt(this.storageGet(this.storageKey), 10);
    if (!lastClosed) return true;
    return (Date.now() - lastClosed) / 86400000 >= this.frequency;
  }

  open() {
    window.clearTimeout(this.timer);
    this.overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    this.querySelector('input, button')?.focus({ preventScroll: true });
  }

  close() {
    window.clearTimeout(this.timer);
    this.overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    this.storageSet(this.storageKey, String(Date.now()));
  }

  async copyCoupon() {
    const coupon = this.copyButton.dataset.copyCoupon;
    const feedback = this.querySelector('.newsletter-popup__copy-feedback');
    try {
      await navigator.clipboard.writeText(coupon);
      this.copyButton.textContent = 'COPIADO';
      feedback.textContent = 'Cupom copiado. Use TOP5 no checkout.';
    } catch {
      feedback.textContent = `Copie o código: ${coupon}`;
    }
  }
}

if (!customElements.get('newsletter-popup')) customElements.define('newsletter-popup', NewsletterPopup);
